import { component } from 'flightjs';
import WithAjax from 'tradera/legacy/static/app/data/with-ajax';

function SmsCheckService() {
    this._smsCheck = function (evt, payload) {
        this._post({
            url: '/login/smscheck',
            data: payload,
            success: 'data:sms-check:query'
        });
    };

    this.after('initialize', function () {
        this.on(document, 'ui:sms-check:query', this._smsCheck);
    });
}

export default component(SmsCheckService, WithAjax);
